export default __webpack_public_path__ + "static/media/22_desktop.8a85aa36.jpg";